import { FileStatus } from "@quantizr-engineering/common/types/file";

export const getStatusBackgroundColor = (status: FileStatus): string => {
  const bgColors = {
    [FileStatus.PENDING]: "bg-[#E9E8ED]",
    [FileStatus.PROCESSING]: "bg-[#F1E5FF]",
    [FileStatus.PROCESSED]: "bg-green-100",
    [FileStatus.ERROR]: "bg-[#D1FAE2]",
  };
  return bgColors[status] ?? "bg-[#E9E8ED]";
};

export const getStatusTextColor = (status: FileStatus): string => {
  const textColors = {
    [FileStatus.PENDING]: "text-[#48455B]",
    [FileStatus.PROCESSING]: "text-[#4932F5]",
    [FileStatus.PROCESSED]: "text-green-800",
    [FileStatus.ERROR]: "text-[#054F36]",
  };
  return textColors[status] ?? "text-[#48455B]";
};

export const getDocumentStatusStyling = (status: FileStatus): string => {
  return `${getStatusBackgroundColor(status)} ${getStatusTextColor(status)}`;
};

export const isDocumentProcessed = (status: FileStatus): boolean => {
  return status === FileStatus.PROCESSED;
};
